module.exports = __webpack_public_path__ + "assets/images/red-circle_1cf2f2a4477bab63683c1bd365b4b758.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forms/red-circle.png
// module id = 143
// module chunks = 0